import { render, staticRenderFns } from "./LearnAboutScreenProfiles.vue?vue&type=template&id=70eb2856&scoped=true"
import script from "./LearnAboutScreenProfiles.vue?vue&type=script&lang=js"
export * from "./LearnAboutScreenProfiles.vue?vue&type=script&lang=js"
import style0 from "./LearnAboutScreenProfiles.vue?vue&type=style&index=0&id=70eb2856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb2856",
  null
  
)

export default component.exports